import { graphql, useStaticQuery } from 'gatsby'
import React, { useMemo } from 'react'
import { injectIntl } from 'react-intl'
import marked from 'marked'
import { findLocalized } from '../utils'


const TextHpIID = ({intl: {locale}}) => {
  const { allTextHpIidYaml } = useStaticQuery(graphql`
    query {
      allTextHpIidYaml{
        edges{
          node{
            text
            lang
          }
        }
      }    
    }
  `);
  const { text } = useMemo(() => findLocalized(allTextHpIidYaml, locale), [allTextHpIidYaml, locale]);
  return (
    <section id="banner-iic" className="section banner-iic text-center" aria-labelledby="banner-iic">
      <div className="container">
        <div className="row" data-aos="fade-up">
          <div className="col-sm-10 offset-sm-1 col-md-8 offset-md-2">
            <div dangerouslySetInnerHTML={{__html: marked(text)}}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default injectIntl(TextHpIID);
